<template>
  <vh-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :dialogCenter="true"
    :custom-class="['std-dialog', size ? `std-dialog--${size}` : ''].join(' ')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot="title" v-if="$slots.title">
      <slot name="title">
        <span class="vh-dialog__title">{{ title }}</span>
      </slot>
    </template>
    <div class="dialog-body mb-0" v-loading="loading">
      <slot></slot>
    </div>
    <template slot="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </template>
  </vh-dialog>
</template>
<script>
  export default {
    name: 'StdDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      size: {
        type: String
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit('update:visible', val);
        }
      }
    }
  };
</script>
<style lang="less">
  :root {
    --max-dialog-height1: 512px;
    --max-dialog-height2: 720px;
  }

  // 弹窗规范样式
  .vh-dialog.std-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 auto !important;

    .vh-button {
      padding: 10px 19px;
    }
    .vh-dialog__body {
      display: flex;
      overflow: auto;
      flex: 1;
      padding: 0 32px;

      .dialog-body {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-bottom: 24px;
        position: relative;
      }
    }

    .vh-dialog__footer {
      padding: 0 32px 24px;

      .dialog-footer {
        display: flex;

        &__hd {
          flex: 1;
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  // 微型弹窗
  .vh-dialog.std-dialog.std-dialog--mini {
    width: 400px;
    min-height: 180px;
    max-height: 512px;
    max-height: min(90vh, var(--max-dialog-height1));
  }

  // 小型弹窗
  .vh-dialog.std-dialog.std-dialog--small {
    width: 520px;
    min-height: 194px;
    max-height: 720px;
    max-height: min(90vh, var(--max-dialog-height2));
  }

  // 中型弹窗
  .vh-dialog.std-dialog.std-dialog--medium {
    width: 800px;
    min-height: 512px;
    max-height: 720px;
    max-height: min(90vh, var(--max-dialog-height2));
  }

  // 大型弹窗
  .vh-dialog.std-dialog.std-dialog--big {
    width: 1020px;
    min-height: 512px;
    max-height: 720px;
    max-height: min(90vh, var(--max-dialog-height2));
  }
</style>
